import type { ReactNode } from 'react'

import { ChipContainer } from './styles'

interface InfoChipProps {
  children: ReactNode
}

export function InfoChip({ children }: InfoChipProps) {
  return <ChipContainer>{children}</ChipContainer>
}
